import React, { useState, useEffect, useContext } from "react";

import {
	HomeOutlined,
	LogoutOutlined,
	TeamOutlined,
	BankOutlined,
	FileTextOutlined,
	BarChartOutlined,
	DatabaseOutlined,
	FileExcelOutlined,
	SettingOutlined,
	ShopOutlined,
	ShoppingCartOutlined,
	CloudUploadOutlined,
	ClusterOutlined,
	FileAddOutlined,
	AppstoreOutlined,
	ApartmentOutlined,	
	UserAddOutlined,
	UserSwitchOutlined,
	UsergroupAddOutlined,
	SunOutlined,
	MoonOutlined,
	FileDoneOutlined,
	ProfileOutlined,
	TagsOutlined,
} from "@ant-design/icons";

import { 
	Layout, 
	Menu, 
	Button, 
	Result, 
	Cascader, 
	Row, 
	Col, 
	Switch,
} from "antd";

import PropTypes from "prop-types";
import { useAuth0 } from "@auth0/auth0-react";

// Pages
import {
	DashBoardStart,
	PurchaseInvoices,
	SalesInvoices,
	Users,
	Companies,
	CompaniesUser,
	UploadInvoices,
	EmitInvoices,
	ReportsInvoices,
	ReportsTransactions,
	DataBases,
	ErrorPool,
	Organizations,
	AdminConfig,
	EntitiesPage,
	BankAccounts,
	IAClassifier,
	Classifications
} from "./pages";

// Services
import { get_companies, get_entities } from "./services";

import { ClassificationRecurrencies } from "./components/invoices";

import { RecurrenciesContext, EntitiesContext, BankAccountProvider, CompaniesContext, MassiveEmitionContext } from "./contexts";
import { UserRols } from "./constants";
import { ClassificationsContext } from "./contexts/ClassificationsContext";

const { Header, Sider, Content } = Layout;

const no_selected_company = {
	id: "",
	name: "",
	country: "",
	address: "",
	is_associated_company: true,
	description: "",
	database_id: "",
	tid: "",
	accounting_resources: {
		diaries: [],
		accounting_plan: [],
		expense_accounts: [],
		sale_accounts: [],
		others:{
			analytic_accounts:[]
		}
	},
	tax_authority_specifications: {
		pequenio_contribuyente: false,
	},
	database:{
		name:"",
		system:"",
		version:""
	}
};

const Home = ({ user, token, setUser, setToken, darkMode, setDarkMode }) => {	
	const { logout } = useAuth0();
	const handleSignOut = () => {
		setUser({});
		setToken({});
		localStorage.removeItem("authToken");
		localStorage.removeItem("companies");
		logout();
	};

	const [current, setCurrent] = useState("Home");	
	const [menuItems, setMenuItems] = useState([
		{ 
			key: "Home", 
			icon: (
				<div style={{ width: 50, marginLeft: -13, display: "flex", flexDirection: "column", alignItems: "center" }}>
					<HomeOutlined />
					<div style={{ fontSize: "10px", marginTop: "4px" }}>Inicio</div>
				</div>
			), 
		},
		{ 
			key: "Sign Out", 
			icon: (
				<div style={{ width: 50, marginLeft: -13, display: "flex", flexDirection: "column", alignItems: "center" }}>
					<LogoutOutlined />
					<div style={{ fontSize: "10px", marginTop: "4px" }}>Salir</div>
				</div>
			),
		},
	]);
	
	const { companies, setCompanies, updateCompaniesIncludingLocalStorage, selectedCompany, setSelectedCompany } = useContext(CompaniesContext);
	const { clearClassifications } = useContext(ClassificationsContext);
	const [clients, setClients] = useState([]);	
	const [loadingCompanies, setLoadingCompanies] = useState(true);

	const [selectorOfCompanies, setSelectorOfCompanies] = useState([]);
	const displayRender = (labels) => labels[labels.length - 1];

	// Necesary Contexts
	const { toggleDrawer } = useContext(RecurrenciesContext);
	const { toggleDrawerMassiveEmition = () => {} } = useContext(MassiveEmitionContext);
	const { 
		setClients : setClientsForContext,
		setSuppliers : setSuppliersForContext,
	} = useContext(EntitiesContext);

	// Función para truncar cadenas con un límite de caracteres
	function truncateString(str, maxLength) {
		if (str.length > maxLength) {
			return str.substring(0, maxLength) + "...";
		}
		return str;
	}

	function agruparPorBasesDeDatos(datosRecibidos) {
		const agrupacion = datosRecibidos.reduce((acc, data) => {
			const dbId = `${truncateString(data.database.name, 20)}_${data.database.system}_${data.database.version}`;

			if (!acc[dbId]) {
				acc[dbId] = {
					value: dbId,
					label: `${truncateString(data.database.name, 20)} _${data.database.system} _${data.database.version}`.toUpperCase(),
					children: []
				};
			}

			acc[dbId].children.push({
				value: data.id,
				label: truncateString(data.name, 40).toUpperCase()
			});

			return acc;
		}, {});

		return Object.values(agrupacion);
	}
	
	const refreshCompanies = async () => {
		try {
			const res = await get_companies(token, "assigned");
	
			if (res && Array.isArray(res) && res.length > 0) {
				// Ordena las companies alfabéticamente por company.name
				const sortedCompanies = res.sort((a, b) => a.name.localeCompare(b.name));
	
				// Asigna las companies ordenadas y realiza las otras acciones
				updateCompaniesIncludingLocalStorage(sortedCompanies);
				
				setSelectorOfCompanies(agruparPorBasesDeDatos(sortedCompanies));
			} else {
				// Si no hay ninguna company, manejarlo adecuadamente
				setCompanies([]); // Puedes dejar una lista vacía
				setSelectorOfCompanies([]); // O lo que consideres apropiado aquí
			}
		} catch (error) {
			console.error("Error fetching companies:", error);
		} finally {
			setLoadingCompanies(false); // Asegurarse de detener el loading, incluso en caso de error
		}
	};
	

	const updateMenuItemsForRole = (role, items) => {
		const updatedList = [...menuItems];
		updatedList.splice(updatedList.length - 1, 0, ...items);
		setMenuItems(updatedList);
	};

	const getItem = (label, key, icon, children = null, marginLeft = -38) => {
		return {
			key,
			icon: (<div style={{ width: 50, marginLeft, display: "flex", flexDirection: "column", alignItems: "center" }}>
				{icon}
				<div style={{ fontSize: "10px", marginTop: "4px" }}>{label}</div>
			</div>),
			children,
		};
	};

	const client_menu = [
		getItem("Facturas", "Invoices", <FileTextOutlined />, [
			getItem("Compras", "PurchaseInvoices", <ShoppingCartOutlined />),
			getItem("Ventas", "SalesInvoices", <ShopOutlined />),
			//getItem("Subir", "UploadInvoices", <CloudUploadOutlined />),
			//getItem("Emitir", "EmitInvoices", <FileAddOutlined />),
		], -13),
		getItem("Reportes", "Reports", <BarChartOutlined />, [
			getItem("Facturas", "InvoiceReport", <FileTextOutlined />),
		], -13),
	];

	const base_menu = [
		getItem("Facturas", "Invoices", <FileTextOutlined />, [
			getItem("Compras", "PurchaseInvoices", <ShoppingCartOutlined />),
			getItem("Ventas", "SalesInvoices", <ShopOutlined />),
			getItem("Subir", "UploadInvoices", <CloudUploadOutlined />),
			getItem("Emitir", "EmitInvoices", <FileAddOutlined />),
		], -13),
		getItem("Reportes", "Reports", <BarChartOutlined />, [
			getItem("Facturas", "InvoiceReport", <FileTextOutlined />),
			getItem("Transacciones", "BankTransactionReport", <FileDoneOutlined />),
		], -13),
		getItem("Empresa", "CompanyConfig", <AppstoreOutlined />, [
			getItem("Clientes", "Clients", <UserAddOutlined />),
			getItem("Proveedores", "Suppliers", <UserSwitchOutlined />),
		], -13),		
		getItem("Bancos", "Banks", <BankOutlined />, [
			getItem("Cuentas", "BankAccounts", <ProfileOutlined />),
			getItem("Clasificaciones", "Classifications", <TagsOutlined />),
		], -13),
	];
	
	const accountant_menu = [
		...base_menu,
		getItem("Config", "OrgConfig", <SettingOutlined />, [
			getItem("Compañías", "CompaniesUser", <BankOutlined />),
		], -13),
	];

	const invoices_menu = [
		getItem("Facturas", "Invoices", <FileTextOutlined />, [
			getItem("Compras", "PurchaseInvoices", <ShoppingCartOutlined />),
			getItem("Ventas", "SalesInvoices", <ShopOutlined />),
			getItem("Subir", "UploadInvoices", <CloudUploadOutlined />),
		], -13),
		getItem("Reportes", "Reports", <BarChartOutlined />, [
			getItem("Facturas", "InvoiceReport", <FileTextOutlined />),
			getItem("Transacciones", "BankTransactionReport", <FileDoneOutlined />),
		], -13),
	];

	const billing_menu = [
		getItem("Facturas", "Invoices", <FileTextOutlined />, [			
			getItem("Ventas", "SalesInvoices", <ShopOutlined />),
			getItem("Emitir", "EmitInvoices", <FileAddOutlined />),
		], -13),
		getItem("Reportes", "Reports", <BarChartOutlined />, [
			getItem("Facturas", "InvoiceReport", <FileTextOutlined />),
			getItem("Transacciones", "BankTransactionReport", <FileDoneOutlined />),
		], -13),
		getItem("Empresa", "CompanyConfig", <AppstoreOutlined />, [
			getItem("Clientes", "Clients", <UsergroupAddOutlined />),
		], -13),
		getItem("Config", "OrgConfig", <SettingOutlined />, [
			getItem("Compañías", "CompaniesUser", <BankOutlined />),
		], -13),
	];
	
	const treasury_menu = [
		getItem("Facturas", "Invoices", <FileTextOutlined />, [
			getItem("Compras", "PurchaseInvoices", <ShoppingCartOutlined />),
			getItem("Ventas", "SalesInvoices", <ShopOutlined />),
			getItem("Emitir", "EmitInvoices", <FileAddOutlined />),
		], -13),
		getItem("Reportes", "Reports", <BarChartOutlined />, [
			getItem("Facturas", "InvoiceReport", <FileTextOutlined />),
			getItem("Transacciones", "BankTransactionReport", <FileDoneOutlined />),
		], -13),
		getItem("Empresa", "CompanyConfig", <AppstoreOutlined />, [
			getItem("Clientes", "Clients", <UsergroupAddOutlined />),
			getItem("Proveedores", "Suppliers", <UserSwitchOutlined />),
		], -13),
		getItem("Config", "OrgConfig", <SettingOutlined />, [
			getItem("Compañías", "CompaniesUser", <BankOutlined />),
		], -13),
		getItem("Bancos", "Banks", <BankOutlined />, [
			getItem("Cuentas", "BankAccounts", <ProfileOutlined />),
			getItem("Clasificaciones", "Classifications", <TagsOutlined />),
		], -13),
	];
	
	const default_user_menu = [
		...invoices_menu,
		getItem("Config", "OrgConfig", <SettingOutlined />, [
			getItem("Compañías", "Companies", <BankOutlined />),
		], -13),
	];

	const org_admin_menu = [
		getItem("Facturas", "Invoices", <FileTextOutlined />, [
			getItem("Compras", "PurchaseInvoices", <ShoppingCartOutlined />),
			getItem("Ventas", "SalesInvoices", <ShopOutlined />),
			getItem("Subir", "UploadInvoices", <CloudUploadOutlined />),
			getItem("Emitir", "EmitInvoices", <FileAddOutlined />),
		], -13),
		getItem("Reportes", "Reports", <BarChartOutlined />, [
			getItem("Facturas", "InvoiceReport", <FileTextOutlined />),
			getItem("Transacciones", "BankTransactionReport", <FileDoneOutlined />),
		], -13),
		getItem("Empresa", "CompanyConfig", <AppstoreOutlined />, [
			getItem("Clientes", "Clients", <UserAddOutlined />),
			getItem("Proveedores", "Suppliers", <UserSwitchOutlined />),
		], -13),
		getItem("Bancos", "Banks", <BankOutlined />, [
			getItem("Cuentas", "BankAccounts", <ProfileOutlined />),
			getItem("Clasificaciones", "Classifications", <TagsOutlined />),
		], -13),
		getItem("Config", "OrgConfig", <SettingOutlined />, [
			getItem("Compañías", "Companies", <BankOutlined />),
			getItem("Usuarios", "OrgUsers", <TeamOutlined />),
			getItem("Bases de Datos", "DataBases", <DatabaseOutlined />),
		], -13),
	];
	const aro_admin_menu = [
		...base_menu,
		getItem("Config", "OrgConfig", <SettingOutlined />, [
			getItem("Compañías", "Companies", <BankOutlined />),
			getItem("Usuarios", "OrgUsers", <TeamOutlined />),
			getItem("DB's", "DataBases", <DatabaseOutlined />),
			getItem("Errores", "ErrorPool", <FileExcelOutlined />),
			getItem("IA", "IA", <ClusterOutlined />),
		], -13),
		getItem("ARO", "Config", <SettingOutlined />, [
			getItem("ORG's", "Organizations", <ApartmentOutlined />),
			getItem("Usuarios", "AdminConfig", <TeamOutlined />),
		], -13),
	];

	useEffect(() => {
		const comps = localStorage.getItem("companies");
		setCompanies(comps ? JSON.parse(comps) : [] );
		setSelectorOfCompanies(agruparPorBasesDeDatos(comps? JSON.parse(comps) : [] ));
		refreshCompanies();

		if (Object.keys(user).length !== 0) {
			if (user.role === UserRols.DEFAULT_USER) {
				updateMenuItemsForRole(UserRols.DEFAULT_USER, default_user_menu);
			}
			if (user.role === UserRols.CLIENT) {
				updateMenuItemsForRole(UserRols.CLIENT, client_menu);
			}
			if (user.role === UserRols.INVOICES) {
				updateMenuItemsForRole(UserRols.INVOICES, invoices_menu);
			}
			if (user.role === UserRols.BILLING) {
				updateMenuItemsForRole(UserRols.BILLING, billing_menu);
			}
			if (user.role === UserRols.ACCOUNTANT) {
				updateMenuItemsForRole(UserRols.ACCOUNTANT, accountant_menu);
			}
			if (user.role === UserRols.ORG_ADMIN) {
				updateMenuItemsForRole(UserRols.ORG_ADMIN, org_admin_menu);
			}
			if (user.role === UserRols.ARO_ADMIN) {
				updateMenuItemsForRole(UserRols.ARO_ADMIN, aro_admin_menu);
			}
			if (user.role === UserRols.TREASURY) {
				updateMenuItemsForRole(UserRols.TREASURY, treasury_menu);
			}
		}
	}, []);

	useEffect(() => {
		if (selectedCompany !== no_selected_company) {
			onChangeCompany(["", selectedCompany.id]);
		}
	}, [companies]);

	const entitiesFilter = (clients, isArchieved) => {
		const filteredClients = isArchieved ? 
			clients.filter(client => client.state === "archieved") : 
			clients.filter(client => client.state === "active") ;
		return filteredClients;
	};

	const onChangeCompany = async (value) => {
		if (value == undefined){
			setSelectedCompany(no_selected_company);
			clearClassifications();
		}
		else {
			setClients([]);
			const found_company = companies.find((element) => element.id === value[1]);
			if (found_company == undefined){
				setSelectedCompany(no_selected_company);
				setClients([]);
				clearClassifications();
			}
			else {				
				setSelectedCompany(found_company);
				clearClassifications();
				
				// Evitar que Invoices obtenga Clientes.
				if(user.role === UserRols.INVOICES || user.role === UserRols.CLIENT){ 
					return;
				}
				
				const localClient = localStorage.getItem(`clients_${found_company.id}`);
				if (localClient) setClients(JSON.parse(localClient));

				setLoadingCompanies(true);

				console.log("asd")
				
				const responseClients = await get_entities(token, found_company.id, "clients");
				if(responseClients){
					setClients(responseClients);					
					setLoadingCompanies(false);
					setClientsForContext(entitiesFilter(responseClients, false));
				} else {
					setClients([]);
					setLoadingCompanies(false);
				}

				const responseSuppliers = await get_entities(token, found_company.id, "suppliers");
				if(responseSuppliers){
					setSuppliersForContext(entitiesFilter(responseSuppliers, false));
					setLoadingCompanies(false);
				}				
			}
		}
	};

	const selectOption = (e) => {
		setCurrent(e.key);
		if (e.key === "Sign Out") handleSignOut();
	};

	const filter = (inputValue, path) => 
		path.some((option) => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);

	const renderContent = () => {
		switch (current) {
		case "AdminConfig":
			return <AdminConfig {...{token}} />;
		case "OrgUsers":
			return <Users {...{token, user, setUser, refreshCompanies}} />;
		case "Companies":
			return (
				<Companies
					{...{ token, user }}
				/>
			);
		case "CompaniesUser":
			return (
				<CompaniesUser
					{...{ token }}
				/>
			);
		case "PurchaseInvoices":
			return (
				<PurchaseInvoices
					{...{user, token, company: selectedCompany }}
				/>
			);
		case "SalesInvoices":
			return (
				<SalesInvoices
					{...{ user, token, company: selectedCompany }}
				/>
			);
		case "UploadInvoices":
			return (
				<UploadInvoices {...{token, companies_of_user : selectorOfCompanies}}/>
			);
		case "EmitInvoices":
			return (
				<EmitInvoices {...{token, user, company : selectedCompany, clients:entitiesFilter(clients || [], false)}}/>
			);
		case "InvoiceReport":
			return (
				<ReportsInvoices				
					{...{ token, user }}
				/>
			);
		case "BankTransactionReport":
			return (
				<ReportsTransactions
					{...{ token }}
				/>
			);
		case "DataBases":
			return (
				<DataBases
					{...{token}}
				/>
			);
		case "Clients":
			return (
				<EntitiesPage
					user={user}
					token={token}
					company={selectedCompany}
					entitySelected="clients"
				/>
			);
		case "Suppliers":
			return (
				<EntitiesPage
					user={user}
					token={token}
					company={selectedCompany}
					entitySelected="suppliers"
				/>
			);
		case "BankAccounts":
			return (
				<BankAccountProvider>
					<BankAccounts
						{...{ token, company: selectedCompany }}
					/>
				</BankAccountProvider>
			);
		case "Classifications":
			return (
				<Classifications
					token={token}
					company={selectedCompany}
				/>
			);
		case "Organizations": // Agrega el caso para el componente Organizations
			return (
				<Organizations
					{...{token}}
				/>
			);
		case "IA":
			return (
				<IAClassifier
					{...{token, company: selectedCompany}}
				/>
			);
		case "ErrorPool":
			return (
				<ErrorPool {...{user, token}}/>
			);
		case "Home":
			return (
				<DashBoardStart
					{...{ token, company: selectedCompany }}
				/>
			);
		default:
			return null;
		}
	};

	return (
		<>
			{user ? (
				<Layout
					hasSider
					style={{
						minHeight: "100vh",
					}}
				>
					<Sider 
						trigger={null}
						reverseArrow={false}
						width={80}
						collapsed={false}
						style={{
							overflow: "auto",
							height: "100vh",
							position: "fixed",
							insetInlineStart: 0,
							top: 0,
							bottom: 0,
							scrollbarWidth: "thin",
							scrollbarColor: "unset",
						}}
					>
						<img 
							src={darkMode? "/logo_white.png" : "/logo.png"} // Si la imagen está en la carpeta "public"
							alt="Logo"
							style={{ width: "auto", height: "52px", marginTop:10, opacity: 0.7 }}  // Ajustes de estilo
						/>
						<Menu
							mode="inline"
							onClick={selectOption}
							expandIcon={null}
							selectedKeys={[current]}
							items={menuItems}
							style={{
								textAlign:"left"
							}}
						/>
					</Sider>
					<Layout
						style={{
							marginInlineStart: 80,
							transition: "margin-inline-start 0.2s ease", // Añade esta línea
						}}>
						<Header
							style={{
								padding: 0,
								paddingLeft:20,
								paddingRight:20,
								paddingTop:5
							}}
						>
							<Row gutter={0}>
								<Col 
									span={4}
									style={{
										textAlign: "left",
									}}
								>
									
									<img 
										src={darkMode? "/name_white.png" : "/name.png"}
										alt="Name"
										style={{ width: "auto", height: "25px", marginTop: "15px", opacity: 0.7 }}  // Ajustes de estilo
									/>
								</Col>
								<Col 
									span={16}
									style={{
										textAlign: "center",
									}}
								>
									{
										(
											current === "Home" ||
											current === "PurchaseInvoices" ||
											current === "SalesInvoices" ||
											current === "InvoiceReport" ||
											current === "BankTransactionReport" ||
											current === "IA" ||
											current === "EmitInvoices" ||
											current === "Clients" ||
											current === "Suppliers" ||
											current === "BankAccounts" || 
											current === "Classifications"
										) && (
											<Cascader
												style={{
													width: 500,
													height: 40,
												}}
												placeholder="Selecciona una empresa"
												options={selectorOfCompanies}
												displayRender={displayRender}
												onChange={onChangeCompany}
												loading={loadingCompanies}
												value={[
													`${truncateString(selectedCompany.database.name, 20)}_${selectedCompany.database.system}_${selectedCompany.database.version}`,
													selectedCompany.id,
												]}
												showSearch={{
													filter,
													matchInputWidth: false,
												}}
											/>
										)
									}
									{
										(current === "EmitInvoices" && <>
											<Button
												type="primary"
												style={{ 
													marginLeft: "10px",
													height:40,
												}}
												onClick={toggleDrawer}
												disabled={JSON.stringify(selectedCompany) === JSON.stringify(no_selected_company)}
											>
												Recurrencias
											</Button>
											<Button
												type="primary"
												style={{ 
													marginLeft: "10px",
													height:40,
												}}
												onClick={toggleDrawerMassiveEmition}
												disabled={JSON.stringify(selectedCompany) === JSON.stringify(no_selected_company)}
												ghost
											>
												Masivo
											</Button>
										</>)
									}
									{
										(
											current == "PurchaseInvoices" &&
										<ClassificationRecurrencies company = {selectedCompany} token = {token} position={"out"} user={user}/>
										)
									}
									{
										(
											current == "SalesInvoices" &&
										<ClassificationRecurrencies company = {selectedCompany} token = {token} position={"in"} user={user}/>
										)
									}
								</Col>
								<Col 
									span={4}
									style={{
										textAlign: "right",
									}}
								>
									<Switch 
										value={darkMode}
										onChange={setDarkMode}
										unCheckedChildren={<SunOutlined />}
										checkedChildren={<MoonOutlined />}
									/>
								</Col>
							</Row>
							
						</Header>
						<Content
							style={{
								margin: "10px 16px",
								padding: 24,
								background: darkMode? "#181a1b" : "white",
								overflow: "initial",
								borderRadius: 20,
							}}
						>
							{renderContent()}
						</Content>
					</Layout>
				</Layout>
			) : (
				<Result
					status="403"
					title="403"
					subTitle="Lo sentimos, no estás autorizado a hacer esto."
					extra={<Button type="primary" >Back Home</Button>}
				/>
			)}
		</>
	);
};

Home.propTypes = {
	user: PropTypes.shape({
		role: PropTypes.string.isRequired
	}).isRequired,
	token: PropTypes.string.isRequired,
	setUser: PropTypes.func.isRequired,
	setToken: PropTypes.func.isRequired,	
	darkMode: PropTypes.bool.isRequired,
	setDarkMode: PropTypes.func.isRequired,
};

export default Home;
